import React from "react";
import { createRoot } from 'react-dom/client';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType
} from "react-router-dom";
import App from "./App";

import * as Sentry from "@sentry/react";
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
    gtmId: 'GTM-TVF3DDTT'
}

TagManager.initialize(tagManagerArgs)

/*ReactGA.initialize('UA-9831859-1');
TagManager.initialize({
    gtmId: 'GTM-P6984K5'
});*/

if(process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: "https://15b9ed1cac294420ae08fca965ee7d54@o160700.ingest.sentry.io/1389767",
        integrations: [
            new Sentry.BrowserTracing({
                // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
                routingInstrumentation: Sentry.reactRouterV6Instrumentation(
                    React.useEffect,
                    useLocation,
                    useNavigationType,
                    createRoutesFromChildren,
                    matchRoutes
                    ),
                }
            ),
            new Sentry.GlobalHandlers({
                onerror: false,
                onunhandledrejection: false
            })
        ],
        sampleRate: 1.0,
        tracesSampleRate: 1.0,
    });
}

createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
